import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AppTableComponent, Form, FormElement, MessagesComponent, OpnIntroductionModel, RequestsService, TranslationManager, ViewState } from 'src/common';

@Component({
  selector: 'opn-introduction',
  templateUrl: 'opn-introduction.component.html'
})

export class OpnIntroductionComponent implements OnInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;

  @Input() requestId: number;
  @Input() state: ViewState;
  form: Form = new Form();
  viewState = ViewState;

  translationManager = TranslationManager;

  constructor(private requestsService: RequestsService) { }

  ngOnInit(): void {
    this.initForm();

    if (this.state === ViewState.Edit || this.state === ViewState.Details) {
      this.requestsService.getRequestSubjectById(this.requestId).then((result: OpnIntroductionModel) => {
        this.form.elements['requestSubject'].value = result.requestSubject;
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  private initForm(): void {
    this.form.elements["requestSubject"] = new FormElement();
  }
}
